import i18n from "@/i18n";
import { AssetTypes } from "@/model/AssetTypes";
import { CustomFieldEditType } from "@/modules/customfields/CustomField.interface";
import CFAttachment, {
  NewAttachmentValue,
} from "@/modules/customfields/fields/CFAttachment";
import { Field, FormRenderProps } from "react-final-form";
// import "./CBRentalAgreementFormWizardStep1UploadContract.scss";

export type CBRentalAgreementFormWizardAdditionalAttachmentsValue = {
  additionalAttachments: NewAttachmentValue[];
};

interface CBRentalAgreementFormWizardAdditionalAttachmentsProps {
  initialValues?: CBRentalAgreementFormWizardAdditionalAttachmentsValue;
  formProps: FormRenderProps<any>;
}
const CBRentalAgreementFormWizardAdditionalAttachments = (
  props: CBRentalAgreementFormWizardAdditionalAttachmentsProps
) => {

  return (
    <div>
      <Field name="additionalAttachments">
        {(field) => (
          <div className={`margin-bottom-20`}>
            <CFAttachment
              field={field}
              accept={{
                "application/pdf": [],
                "image/jpeg": [],
                "image/png": [],
              }}
              assetType={AssetTypes.Rental.RentalAgreement}
              data={{
                displayName: i18n.t(
                  "cb:RentalAgreement.Form.AdditionalAttachments",
                  "Weitere Anhänge"
                ),
                fieldType: CustomFieldEditType.attachment,
                id: "attachments",
                validation: [],
              }}
            />
          </div>
        )}
      </Field>
    </div>
  );
};

export default CBRentalAgreementFormWizardAdditionalAttachments;
